import React from "react";
import { Box, Typography, ListItem, ListItemIcon } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as CheckMarkCircle } from "../../../icons/CheckMarkCircle.svg";
import { useCurrentBrand } from "../../../hooks/useCurrentWorkspace";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(2.5),
  },
  titleBox: {
    display: "flex",
    alignItems: "center",
    gap: 0,
    flexDirection: "column",
    marginBottom: theme.spacing(2),

    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      gap: theme.spacing(2),
      marginBottom: 0,
    },
  },
  title: {
    fontSize: 32,
    fontWeight: "bold",
    color: theme.palette.common.black,
    marginBottom: theme.spacing(1),
  },
  statusBox: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(0.5, 2),
    flexShrink: 0,
    marginBottom: 4,
  },
  status: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
  },
  text: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.common.black,
  },
  features: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    marginBottom: theme.spacing(4.5),
    marginTop: theme.spacing(3),
  },
  feature: {
    "&:not(:last-child)": {
      marginBottom: theme.spacing(3.5),
    },

    [theme.breakpoints.up("md")]: {
      "&:not(:last-child)": {
        marginBottom: theme.spacing(3.5),
      },
    },
  },
  check: {
    marginRight: theme.spacing(1.25),

    "& svg": {
      width: 30,
      height: 30,
      color: theme.palette.primary.main,
    },
  },
  sublist: {
    marginTop: theme.spacing(-3),
    marginLeft: theme.spacing(8),
    paddingLeft: theme.spacing(2),
    listStyleType: "disc",
  },
}));

interface ReadyForPublishContentProps {}

export function ReadyForPublishContent() {
  const s = useStyles();
  const { brandName } = useCurrentBrand();

  return (
    <Box className={s.header}>
      <Box className={s.titleBox}>
        <Typography className={s.title}>{brandName} Branded App</Typography>
        <Box className={s.statusBox}>
          <Typography className={s.status}>ready for publishing</Typography>
        </Box>
      </Box>
      <Typography className={s.text}>
        Congratulations! Your branded app is in the final stages and will be
        published very soon. Our team is handling the last steps to make your
        app available in the app stores.
      </Typography>
      <Typography className={s.text} sx={{ marginTop: 2 }}>
        You will receive a notification as soon as your app is live. Thank you
        for your patience and excitement!
      </Typography>
    </Box>
  );
}
